export const PAGE_TEMPLATE = 'page-template=19335';
